import { useSelector } from "react-redux";
import { UserMenu } from "./UserMenu";
import { Box, Drawer, IconButton, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import { SideMenu } from "./SideMenu";
import { formatLabel } from "../utils/itemUtil";

const Header = () => {
  const location = useLocation();
  const user = useSelector((state) => state.login.user);
  const [open, setOpen] = useState(false);

  const theme = useTheme();
  const isCompact = useMediaQuery(theme.breakpoints.down("sm"));

  const { item } = useSelector((state) => state.itemContext);

  let title = "Snoop";
  if (location.pathname.startsWith("/popular")) title = "Popular";
  if (location.pathname.startsWith("/activities")) title = "Snoop";
  if (location.pathname.startsWith("/create-item")) title = "Create Item";
  if (location.pathname.startsWith("/browse")) title = "Browse";
  if (location.pathname.startsWith("/login")) title = "Login";
  if (location.pathname.startsWith("/sign-up")) title = "Sign-Up";
  if (location.pathname.startsWith("/items/")) {
    // title = 'Stuff';
    if (item) {
      title = formatLabel(item?.tag?.name) || "Stuff";
    }
    // console.log('item', item);
  }
  if (location.pathname.startsWith("/user/")) title = "Profile";
  if (location.pathname.startsWith("/admin")) title = "Admin";
  if (location.pathname.startsWith("/share-experience")) title = "Share Experience";
  if (location.pathname.startsWith("/forgot-password")) title = "Forgot Password";
  if (location.pathname.startsWith("/site-tickets")) title = "Site Tickets";
  if (location.pathname.startsWith("/shop")) title = "Shop";
  if (location.pathname.startsWith("/privacy")) title = "Privacy";
  if (/^\/user\/[a-z0-9-]+\/friends$/.test(location.pathname)) title = "Friends";
  if (/^\/user\/[a-z0-9-]+\/settings$/.test(location.pathname)) title = "Settings";
  if (/^\/user\/[a-z0-9-]+\/followers$/.test(location.pathname)) title = "Followers";

  const handleMenuClick = () => {
    setOpen(true);
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        padding: "8px",
        height: "64px", // keeps consistent height
        backgroundColor: "appShell.chrome",
        borderBottom: (theme) => `3px solid ${theme.palette.appShell.accent}`,
      }}
    >
      {/* Left side */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {/* Could add left content here if needed */}
        {isCompact ? (
          <>
            <IconButton onClick={handleMenuClick} aria-label="Open menu">
              <MenuIcon sx={{ color: "appShell.chromeText" }} />
            </IconButton>
            <Drawer
              open={open}
              variant="temporary"
              onClose={() => setOpen(false)}
              PaperProps={{ sx: { backgroundColor: "appShell.chrome" } }}
            >
              <SideMenu mobile={true} onClick={() => setOpen(false)} />
            </Drawer>
          </>
        ) : (
          <>
            <Typography variant="h5" component="span" sx={{ color: "appShell.brandText", fontWeight: 800, letterSpacing: "-1px" }}>
              nosi
            </Typography>
            <Typography variant="h5" component="span" sx={{ color: "appShell.brandAccent", fontWeight: 800, letterSpacing: "-1px" }}>
              .io
            </Typography>
          </>
        )}
      </Box>

      {/* Center title */}
      <Typography
        variant="h5"
        component="div"
        sx={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          margin: 0,
          color: "appShell.chromeText",
          maxWidth: "50%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>

      {/* Right side */}
      <Box sx={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
        {user ? (
          <UserMenu user={user} />
        ) : title !== "Login" ? (
          <>
            <Link to="/sign-up" style={{ color: theme.palette.appShell.chromeText, marginRight: "8px" }}>
              Sign-Up
            </Link>
            <Link to="/login" style={{ color: theme.palette.appShell.chromeText, marginRight: "8px" }}>
              Login
            </Link>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default Header;
